import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/map';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UiService } from '../ui/ui.service';

interface UserInfo {
  address: string;
  date_of_birth: Date;
  email: string;
  gender: string;
  name: string;
  phone: null;
  type: string;
}

export enum UserType {
  ADMIN = 2,
  ALUMNI,
  TEACHER,
  STUDENT,
}

@Injectable()
export class UserService {
  public info = null;
  public gdpr = false;

  public details = null;
  public logo = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private ui: UiService
  ) {}

  get role() {
    if (this.info) {
      switch (this.info.type) {
        case '1':
          return 'super-admin';
        case '2':
          return 'admin';
        case '3':
          return 'alumni';
        case '4':
          return 'teacher';
        case '5':
          return 'student';
      }
    }
    return '';
  }

  get userBranchId() {
    return (
      this.details &&
      this.details.emba_user &&
      this.details.emba_user.classes &&
      this.details.emba_user.classes.programme &&
      this.details.emba_user.classes.programme.branch_id
    );
  }

  get logoUrl() {
    return this.logo;
  }

  set logoUrl(url) {
    this.logo = url;
  }

  getLogo(payload, callback) {
    this.http.get('/bmi-others/logo?branchId=' + payload).subscribe(
      (res: any) => {
        if (!res.length) {
          this.logoUrl = environment.basePath + '/' + res.file.path + '/' + res.file.enc_name + '.' + res.file.extension;
        }
        callback(res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  loggedIn() {
    return Observable.create((obs) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        if (this.info) {
          obs.next(true);
          return;
        }
        this.ui.loader.show();
        this.http
          .get('/user/me')
          .concatMap((res1) =>
            this.http.post('/auth/refresh', {}).map((res2) => [res1, res2])
          )
          .subscribe(
            (res: any) => {
              this.ui.loader.hide();
              if (res[0].type != UserType.ALUMNI) {
                console.log(res[0]);
                obs.next(false);
                localStorage.removeItem('access_token');
              } else {
                let imagePath =
                  (res[0].image && environment.basePath + '/' + res[0].image) ||
                  '../assets/img/user.png';
                localStorage.setItem('imagePath', imagePath);
                this.details = res[0];
                this.info = res[0];
                if (res[0].gdpr_acceptance == 'D') {
                  this.logout();
                } else {
                  if (res[1] && res[1].access_token) {
                    localStorage.setItem('access_token', res[1].access_token);
                  }
                  obs.next(true);
                }
              }
            },
            (err) => {
              this.ui.loader.hide();
              obs.next(false);
              localStorage.removeItem('access_token');
            }
          );
      } else {
        obs.next(false);
      }
    });
  }

  login(user_credentials, callback) {
    const payload = {
      ...user_credentials,
      type: UserType.ALUMNI + '',
    };
    this.http.post('/auth/login', payload).subscribe(
      (res: any) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  signup(email, type, callback) {
    const payload = {
      email,
      type,
      link: environment.baseUrl + '/signup/complete/',
    };
    payload['gdpr_acceptance'] = 'A';
    this.http.post('/auth/register', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  logout() {
    this.ui.loader.show();
    this.http
      .post('/auth/logout', {})
      .pipe(finalize(() => this.ui.loader.hide()))
      .subscribe(
        (res) => {
          this.info = null;
          localStorage.removeItem('access_token');
          localStorage.removeItem('imagePath');
          localStorage.removeItem('previousUrl');
          localStorage.removeItem('selectedDropdown');
          localStorage.removeItem('termsAccepted');
          this.router.navigate(['login']);
          // location.reload(true);
        },
        (err) => {
          this.info = null;
          localStorage.removeItem('access_token');
          localStorage.removeItem('imagePath');
          localStorage.removeItem('previousUrl');
          localStorage.removeItem('selectedDropdown');
          localStorage.removeItem('termsAccepted');
          this.router.navigate(['login']);
          // location.reload(true);
        }
      );
  }

  getUserDetails() {
    if (this.loggedIn) {
    }
  }

  getUserInfo() {
    this.ui.loader.show();
    return Observable.create((obs) => {
      this.http
        .get('/user/me')
        .concatMap((res1) =>
          this.http.get('/auth/me').map((res2) => [res1, res2])
        )
        .subscribe(
          (res: any) => {
            //let imagePath = (res.image && (environment.basePath + '/' + res.image)) || '../assets/img/user.png';
            //localStorage.setItem("imagePath", JSON.stringify(imagePath));
            console.log(res[0]);
            localStorage.setItem('userDetails', JSON.stringify(res[0]));
            localStorage.setItem('access_token', res[1].access_token);
            if (
              res[0].student_detail == null ||
              res[0].student_detail == 'null'
            ) {
              res[0].student_detail = {
                designation: '',
                company_name: '',
              };
            }
            if (
              res[0].name == '' ||
              res[0].student_detail.designation == '' ||
              res[0].student_detail.company_name == ''
            ) {
              obs.next(false);
            } else if (res[1].gdpr_acceptance == 'D') {
              obs.next(res[1].gdpr_acceptance);
            } else {
              obs.next(true);
            }
            this.ui.loader.hide();
          },
          (err) => {
            this.ui.loader.hide();
            /* localStorage.removeItem('access_token'); */
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/services/user/user.service.ts